module.exports = __webpack_public_path__ + "static/media/highinvest.27d1d6ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/icons/highinvest.svg
// module id = 1144
// module chunks = 0